import * as React from "react";
import { SVGProps } from "react";
const SvgLogoWebhook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-webhook_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.936 8.147c-1.744-.874-2.383-2.035-1.96-3.455.37-1.251 1.623-2.07 2.898-1.878.636.096 1.196.357 1.632.854.66.752.809 1.63.607 2.608l1.506.409c.642-1.76-.11-3.815-1.754-4.87a4.313 4.313 0 0 0-5.38.564c-.76.748-1.174 1.66-1.27 2.715-.137 1.493.48 2.697 1.516 3.728l-1.648 2.763-.142.01c-.076.004-.135.008-.194.016-1.084.154-1.846 1.117-1.664 2.1.206 1.11 1.216 1.79 2.253 1.52 1.1-.289 1.685-1.35 1.27-2.44-.15-.395-.057-.648.131-.958.53-.875 1.052-1.755 1.584-2.651l.615-1.035Zm3.732 1.322-1.594-2.81.077-.189c.052-.126.1-.242.14-.36.21-.624.083-1.193-.317-1.699A1.831 1.831 0 0 0 8.9 3.846a1.839 1.839 0 0 0-1.174 1.801c.032.807.574 1.528 1.413 1.673.503.087.75.326.972.737.474.874.965 1.74 1.457 2.605.194.342.389.685.582 1.028 1.646-1.097 3.008-1.063 4.025.08.881.99.9 2.498.043 3.51-1.004 1.186-2.356 1.233-3.902.232l-1.229 1.027c1.566 1.562 3.8 1.77 5.568.554 1.721-1.185 2.32-3.459 1.444-5.38-.726-1.589-2.749-3.074-5.432-2.244Zm-3.563 4.795h3.23c.045.06.087.12.128.177.086.121.167.236.262.338.684.731 1.84.767 2.57.089a1.829 1.829 0 0 0 .077-2.62c-.701-.718-1.899-.787-2.55-.026-.394.462-.8.517-1.324.508-.959-.014-1.918-.011-2.877-.009l-1.154.003c.087 1.889-.628 3.066-2.045 3.346-1.387.274-2.665-.434-3.115-1.726-.511-1.467.12-2.64 1.947-3.572l-.414-1.5C1.85 9.706.357 11.636.51 13.808c.137 1.917 1.684 3.62 3.576 3.924a4.308 4.308 0 0 0 2.888-.514c1.153-.653 1.821-1.681 2.13-2.954Z"
        fill="url(#logo-webhook_svg__b)"
      />
    </g>
    <defs>
      <linearGradient
        id="logo-webhook_svg__b"
        x1={9.5}
        y1={1.125}
        x2={9.5}
        y2={17.878}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A86FF" />
        <stop offset={1} stopColor="#17C4C4" />
      </linearGradient>
      <clipPath id="logo-webhook_svg__a">
        <path fill="#fff" transform="translate(.5)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoWebhook;
